import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getFdd } from '@/actions/fdd/getFdd';
import { Fdd } from '@/types/fdd.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetFddReturn {
  result: ApiResponse<Fdd> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetFdd = (): UseGetFddReturn => {
  const query: UseQueryResult<ApiResponse<Fdd>, Error> = useQuery({
    queryKey: ['fdd'],
    queryFn: () => getFdd(),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
